export const getArchiveWidgetData = (state) => state.archiveWidget;
